// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Palette generated by Material Palette - materialpalette.com/teal/blue */
/* TODO: update references in code to above values */
:root {
  --production-primary-color: #1c3557;
  --secondary-color: #65758f;
  --production-accent-color: #65758f;
  --alternating-row-color: #e6e9ed;
  --panel-header-color: #65758f;
}

/* primary color */
/* warning message / error */
/* hyperlinks */
/* button */
/* secondary color light */
/* secondary accent color */
/* borders */
/* text colors and weight */
/* light on dark */
/* dialog */
/* page header */
/* dark */
/* filter and menu */
/* grid */
/* panels */
/* light on dark */
/* search control (header) */
/* primary color */
/* expansion panel / card */
/* input controls */
.combined-header {
  position: relative;
  width: 100%;
  margin-top: 0;
  z-index: 2;
}
.combined-header .fixed-header {
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  vertical-align: central;
  height: 60px !important;
  background-color: var(--production-accent-color);
}
.combined-header .fixed-header .business-key {
  margin: 0px 10px 0px 10px;
}
.combined-header .fixed-header .info-container {
  flex: 1 1 auto;
  margin-left: 12px !important;
}
.combined-header ::ng-deep .header-title a {
  color: #0000ee !important;
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
}
.combined-header ::ng-deep .case-header {
  display: flex;
  justify-content: space-between;
}
.combined-header ::ng-deep .case-header a {
  color: #0000ee !important;
  text-decoration: underline;
  cursor: pointer;
  padding-right: 10px;
  font-size: 16px;
}
.combined-header .fixed-header .button-container {
  flex: 0 auto;
  text-align: end;
  margin-right: 0 !important;
  padding-right: 0 !important;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
}
.combined-header .fixed-header .button-container cf2-search-input {
  flex: 0 auto;
  padding-right: 14px;
}
.combined-header .fixed-header .button-container .menu {
  flex: 0 auto;
  margin-top: 18px !important;
}
.combined-header .fixed-header .button-container .menu-noSearch {
  margin-bottom: 30px !important;
}
.combined-header .fixed-header .button-container .menu-filter {
  flex: 0 auto;
  margin-top: 16px !important;
}
.combined-header .fixed-header .button-container .filter-hidden {
  visibility: hidden;
  display: none;
}
.combined-header .pinned-content {
  margin: 0;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  height: auto !important;
  min-height: auto !important;
  visibility: hidden;
  display: none;
  background-color: #f6f5f7 !important;
  border-bottom: 2px solid var(--production-accent-color) !important;
}
.combined-header .pinned-content ::ng-deep mat-label {
  color: #000000 !important;
}

.production.combined-header .fixed-header {
  background-color: var(--production-accent-color);
}

.page-container {
  position: relative;
  top: 0;
  padding: 25px !important; /* Safari */
  display: -ms-flex; /* IE 10 */
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  min-height: calc(100% - 80px);
  height: calc(100% - 80px);
  width: calc(100% - 2px);
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}
.page-container .page-content-container { /* Safari */ /* IE 10 */
  flex: 1;
  width: 100%;
  top: 60px !important;
}
.page-container .sub-drawer-inactive {
  z-index: 0;
  background-color: #f6f5f7 !important; /* Safari */ /* IE 10 */
  flex: 0;
  width: 0;
  background-color: #f6f5f7;
  visibility: hidden;
  display: none;
}
.page-container .sub-drawer-active {
  z-index: 1;
  background-color: #f6f5f7 !important; /* Safari */ /* IE 10 */
  flex: 0 250px;
  width: 250px;
  background-color: #f6f5f7;
  visibility: visible;
  display: initial;
}
.page-container .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  filter: alpha(opacity=50);
  -ms-opacity: 0.5;
  opacity: 0.5;
  z-index: 10000;
}

/*
  Position the spinner overtop of incoming content
*/
.spinner-wrapper {
  left: 50%;
  top: 50%;
  margin-top: -50%;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/assets/images/spinner.gif");
  width: 100px;
  height: 100px;
  margin: 0 auto;
  position: fixed;
}

/* hide entire header */
.header-hidden {
  visibility: hidden;
  display: none;
}

.email {
  width: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.scss","webpack://./src/app/shared/components/header-row/header-row.component.scss"],"names":[],"mappings":"AAAA,0EAAA;AAQA,oDAAA;AAMA;EACE,mCAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,6BAAA;ACXF;;AD6ByB,kBAAA;AAIzB,4BAAA;AAIA,eAAA;AAGA,WAAA;AAC0B,0BAAA;AACK,2BAAA;AAE/B,YAAA;AAGA,2BAAA;AAC8B,kBAAA;AAM9B,WAAA;AAIA,gBAAA;AAM8B,SAAA;AAE9B,oBAAA;AASA,SAAA;AASA,WAAA;AAQmC,kBAAA;AAInC,4BAAA;AAE+B,kBAAA;AAE/B,2BAAA;AAIA,mBAAA;AC9GA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AA6BF;AA3BE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gDDJW;ACiCf;AA3BI;EACE,yBAAA;AA6BN;AAzBE;EACE,cAAA;EACA,4BAAA;AA2BJ;AAxBE;EACE,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,eDsCe;ACZnB;AAvBE;EACE,aAAA;EACA,8BAAA;AAyBJ;AAvBI;EACE,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,eD0Ba;ACDnB;AArBE;EACE,YAAA;EACA,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAuBJ;AArBI;EACE,YAAA;EACA,mBAAA;AAuBN;AApBI;EACE,YAAA;EACA,2BAAA;AAsBN;AAnBI;EACE,8BAAA;AAqBN;AAlBI;EACE,YAAA;EACA,2BAAA;AAoBN;AAjBI;EACE,kBAAA;EACA,aAAA;AAmBN;AAfE;EAEE,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,kEAAA;AAgBJ;AAfI;EACE,yBAAA;AAiBN;;AAXE;EACE,gDDnGsB;ACiH1B;;AAVA;EACE,kBAAA;EACA,MAAA;EACA,wBAAA,EAEA,WAAA;EACA,iBAAA,EAAA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,6BAAA;AAYF;AAVE,0CAGE,WAAA,EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,oBAAA;AAUJ;AALE;EACE,UAAA;EACA,oCAAA,EACA,WAAA,EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,yBDlIkB;ECmIlB,kBAAA;EACA,aAAA;AAOJ;AAJE;EACE,UAAA;EACA,oCAAA,EACA,WAAA,EACA,UAAA;EACA,aAAA;EACA,YD7EW;EC8EX,yBD9IkB;EC+IlB,mBAAA;EACA,gBAAA;AAMJ;AAHE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAKJ;;AADA;;CAAA;AAGA;EACE,SAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;EACA,mDAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAIF;;AADA,uBAAA;AACA;EACE,kBAAA;EACA,aAAA;AAIF;;AADA;EACE,YAAA;AAIF","sourcesContent":["/* Palette generated by Material Palette - materialpalette.com/teal/blue */\n\n$production-primary-color: var(--production-primary-color);\n$production-accent-color: var(--production-accent-color);\n$secondary-color: var(--secondary-color);\n$alternating-row-color: var(--alternating-row-color);\n$panel-header-color: var(--panel-header-color);\n\n/* TODO: update references in code to above values */\n$primary-color: var(--production-primary-color);\n$accent-color: var(--production-accent-color);\n$primary-color-light: #f6f5f7;\n$primary-color-dark: #00796b;\n\n:root{\n  --production-primary-color: #1c3557;\n  --secondary-color: #65758f;\n  --production-accent-color: #65758f;\n  --alternating-row-color: #e6e9ed;\n  --panel-header-color: #65758f;\n}\n\n// Primary red shades\n// Not in use\n// $red--production-primary-color: #931438;\n// $red--production-accent-color: #f1cddf;\n\n// primary blue shades\n//$production-primary-color: #1c3557; // rgb(28,53,87)   /// CF261 - Dynamic Themes\n//$production-accent-color: #c9d6e9;   /// CF261 - Dynamic Themes\n\n$training-primary-color: #995f7b;\n\n//$secondary-color: #65758f;   /// CF261 - Dynamic Themes\n$secondary-accent-color: #c9ccd1;\n$secondary-color-light: #e6e9ed;\n\n$divider-color: #401d5a; /* primary color */\n\n$cf-hover: rgba(#757575, 0.04);\n\n/* warning message / error */\n$warning-color: #ff0000;\n$warning-color-background: #ffadad;\n\n/* hyperlinks */\n$link-color: #0000ee;\n\n/* button */\n$disabled-color: #f6f5f7; /* secondary color light */\n$disabled-text-color: #c9ccd1; /* secondary accent color */\n\n/* borders */\n$border-color: #212121;\n\n/* text colors and weight */\n$primary-color-text: #ffffff; /* light on dark */\n$readonly-richtext-color: #fafafa;\n$primary-text-color: #212121;\n$secondary-text-color: #757575;\n$primary-text-weight: 400;\n\n/* dialog */\n$dialog-header-text-size: 16px;\n$dialog-header-text-weight: 600;\n\n/* page header */\n$header-height: 60px;\n$header-text-size: 16px;\n$header-text-weight: 700;\n$subheader-text-size: 16px;\n$subheader-text-weight: 600;\n$header-label-color: #000000; /* dark */\n\n/* filter and menu */\n$filter-width: 250px;\n$menu-width: 220px;\n$menu-padding-top: 60px;\n$menu-text-size: 16px;\n$menu-text-weight: 500;\n$menu-child-text-size: 14px;\n$menu-child-text-weight: 400;\n\n/* grid */\n//$alternating-row-color: #e6e9ed; /* secondary color light*/   /// CF261 - Dynamic Themes\n$row-height: 34px;\n$row-header-height: 34px;\n$row-header-text-size: 14px;\n$row-header-text-weight: 500;\n$row-header-text-size-small: 12px;\n$table-text-size-small: 12px;\n\n/* panels */\n//$panel-header-color: #65758f; /* secondary color */   /// CF261 - Dynamic Themes\n$panel-height: 40px;\n$panel-height-small: 20px;\n$panel-height-medium: 30px;\n$panel-header-text-size: 16px;\n$panel-header-text-weight-small: 200;\n$panel-header-text-weight: 500;\n$panel-header-text-color: #ffffff; /* light on dark */\n\n$audit-text-size: 12px;\n\n/* search control (header) */\n$search-text-size: 14px;\n$search-border-color: #401d5a; /* primary color */\n\n/* expansion panel / card */\n$min-card-width: 270px;\n$large-card-width: 540px;\n\n/* input controls */\n$large-input-width: 200px;\n$large-input-height: 78px;\n$large-input-height-disabled: 58px;\n$small-input-width: 160px;\n\n$input-field-padding: 0 5px 0 5px;\n$input-field-margin: 5px 0 0 20px;\n$input-field-margin-no-left: 5px 0 0 0;\n$input-text-weight: 400;\n$input-field-top: -20px;\n$input-text-size: 12px;\n\n$input-field-padding-small: 0 5px 0 5px;\n$input-field-margin-small: 5px 0 0 10px;\n\n$label-text-size: 12px;\n$label-text-weight: 500;\n\n$min-form-field-width: 200px;\n$mid-form-field-width: 250px;\n$grid-column-gap: 16px;\n","@import 'variables';\n\n.combined-header {\n  position: relative;\n  width: 100%;\n  margin-top: 0;\n  z-index: 2;\n\n  .fixed-header {\n    display: flex;\n    flex-direction: row;\n    flex-flow: row nowrap;\n    vertical-align: central;\n    height: $header-height !important;\n    background-color: $accent-color;\n\n    .business-key {\n      margin: 0px 10px 0px 10px;\n    }\n  }\n\n  .fixed-header .info-container {\n    flex: 1 1 auto;\n    margin-left: 12px !important;\n  }\n\n  ::ng-deep .header-title a {\n    color: $link-color !important;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: $header-text-size;\n  }\n\n  ::ng-deep .case-header {\n    display: flex;\n    justify-content: space-between;\n\n    a {\n      color: $link-color !important;\n      text-decoration: underline;\n      cursor: pointer;\n      padding-right: 10px;\n      font-size: $header-text-size;\n    }\n  }\n\n  .fixed-header .button-container {\n    flex: 0 auto;\n    text-align: end;\n    margin-right: 0 !important;\n    padding-right: 0 !important;\n    margin-top: 10px !important;\n    display: flex;\n    flex-direction: row;\n    flex-flow: row nowrap;\n\n    cf2-search-input {\n      flex: 0 auto;\n      padding-right: 14px;\n    }\n\n    .menu {\n      flex: 0 auto;\n      margin-top: 18px !important;\n    }\n\n    .menu-noSearch {\n      margin-bottom: 30px !important;\n    }\n\n    .menu-filter {\n      flex: 0 auto;\n      margin-top: 16px !important;\n    }\n\n    .filter-hidden {\n      visibility: hidden;\n      display: none;\n    }\n  }\n\n  .pinned-content {\n    // padding: 26px !important;\n    margin: 0;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 100%;\n    height: auto !important;\n    min-height: auto !important;\n    visibility: hidden;\n    display: none;\n    background-color: $primary-color-light !important;\n    border-bottom: 2px solid $accent-color !important;\n    ::ng-deep mat-label {\n      color: $header-label-color !important;\n    }\n  }\n}\n\n.production.combined-header {\n  .fixed-header {\n    background-color: $production-accent-color;\n  }\n}\n\n.page-container {\n  position: relative;\n  top: 0;\n  padding: 25px !important;\n  // margin-top: 0 !important;\n  display: -webkit-flex; /* Safari */\n  display: -ms-flex; /* IE 10 */\n  display: flex;\n  flex-direction: row;\n  flex-flow: row nowrap;\n  min-height: calc(100% - 80px);\n  height: calc(100% - 80px);\n  width: calc(100% - 2px);\n  overflow-y: scroll !important;\n  overflow-x: hidden !important;\n\n  .page-content-container {\n    // padding: 26px !important;\n    // margin: 0 20px 0 20px !important;\n    -webkit-flex: 1; /* Safari */\n    -ms-flex: 1; /* IE 10 */\n    flex: 1;\n    width: 100%;\n    top: $header-height !important;\n    // height: calc(100% - $header-height + 10px) !important;\n    // min-height: calc(100% - $header-height + 10px) !important;\n  }\n\n  .sub-drawer-inactive {\n    z-index: 0;\n    background-color: $primary-color-light !important;\n    -webkit-flex: 0; /* Safari */\n    -ms-flex: 0; /* IE 10 */\n    flex: 0;\n    width: 0;\n    background-color: $primary-color-light;\n    visibility: hidden;\n    display: none;\n  }\n\n  .sub-drawer-active {\n    z-index: 1;\n    background-color: $primary-color-light !important;\n    -webkit-flex: 0 $filter-width; /* Safari */\n    -ms-flex: 0 $filter-width; /* IE 10 */\n    flex: 0 $filter-width;\n    width: $filter-width;\n    background-color: $primary-color-light;\n    visibility: visible;\n    display: initial;\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #000;\n    filter: alpha(opacity=50);\n    -ms-opacity: 0.5;\n    opacity: 0.5;\n    z-index: 10000;\n  }\n}\n\n/*\n  Position the spinner overtop of incoming content\n*/\n.spinner-wrapper {\n  left: 50%;\n  top: 50%;\n  margin-top: -50%;\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url('/assets/images/spinner.gif');\n  width: 100px;\n  height: 100px;\n  margin: 0 auto;\n  position: fixed;\n}\n\n/* hide entire header */\n.header-hidden {\n  visibility: hidden;\n  display: none;\n}\n\n.email {\n  width: 1.5em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
